import { makeWorkbook } from "../../utils/excel";
import {
  getIndicatorGenderCounter,
  getIndicatorSchoolQualificationsCounter,
  getIndicatorQualificationLevelsCounter,
  getIndicatorAgeCounter,
} from "../../../../../../rest/indicator";

function genderLabel(code) {
  const c = Number(code);
  if (c === 0) return "Masculino";
  if (c === 1) return "Feminino";
  return String(code);
}

const pctFrac = (v, t) => (t > 0 ? Number(v) / Number(t) : 0);
const sumBy = (arr, key = "counter") =>
  Array.isArray(arr) ? arr.reduce((s, i) => s + Number(i?.[key] || 0), 0) : 0;

export async function buildWorkbookRepresentative() {
  const [respGender, respSchool, respQual, respAge] = await Promise.all([
    getIndicatorGenderCounter(),
    getIndicatorSchoolQualificationsCounter(),
    getIndicatorQualificationLevelsCounter(),
    getIndicatorAgeCounter(),
  ]);

  const genders = (respGender?.data?.data ?? []).map((g) => ({
    gender: g?.gender,
    counter: Number(g?.counter || 0),
  }));

  const schools = (respSchool?.data?.data ?? []).map((s) => ({
    code: s?.code ?? "-",
    counter: Number(s?.counter || 0),
  }));

  const qualifications = (respQual?.data?.data ?? []).map((q) => ({
    code: q?.code ?? "-",
    counter: Number(q?.counter || 0),
  }));

  const ageRow = Array.isArray(respAge?.data?.data)
    ? respAge.data.data[0] || {}
    : {};
  const agesArray = [
    { label: "15-24", counter: Number(ageRow?.from15To24 || 0) },
    { label: "25-34", counter: Number(ageRow?.from25To34 || 0) },
    { label: "35-44", counter: Number(ageRow?.from35To44 || 0) },
    { label: "45-54", counter: Number(ageRow?.from45To54 || 0) },
    { label: "55-64", counter: Number(ageRow?.from55To64 || 0) },
    { label: "> 65", counter: Number(ageRow?.more65 || 0) },
  ];

  const totalGender = sumBy(genders);
  const totalSchools = sumBy(schools);
  const totalQualifications = sumBy(qualifications);
  const totalAges = sumBy(agesArray);

  const resumoAoa = [
    ["Indicador", "Valor"],
    ["Total (Género)", totalGender],
    ["Total (Grupo Etário)", totalAges],
    ["Total (Habilitação Escolar)", totalSchools],
    ["Total (Nível de Qualificação)", totalQualifications],
  ];

  const gendersAoa = [
    ["Género", "Total", "% do total"],
    ...genders
      .slice()
      .sort((a, b) => b.counter - a.counter)
      .map((g) => [
        genderLabel(g.gender),
        g.counter,
        pctFrac(g.counter, totalGender),
      ]),
  ];

  const agesAoa = [
    ["Grupo Etário", "Total", "% do total"],
    ...agesArray.map((a) => [
      a.label,
      a.counter,
      pctFrac(a.counter, totalAges),
    ]),
  ];

  const schoolsAoa = [
    ["Habilitação Escolar", "Total", "% do total"],
    ...schools
      .slice()
      .sort((a, b) => b.counter - a.counter)
      .map((s) => [
        String(s.code),
        s.counter,
        pctFrac(s.counter, totalSchools),
      ]),
  ];

  const qualAoa = [
    ["Nível de Qualificação", "Total", "% do total"],
    ...qualifications
      .slice()
      .sort((a, b) => b.counter - a.counter)
      .map((q) => [
        String(q.code),
        q.counter,
        pctFrac(q.counter, totalQualifications),
      ]),
  ];

  return makeWorkbook([
    { name: "Resumo", aoa: resumoAoa },
    { name: "Genero", aoa: gendersAoa, percentCols: [2] },
    { name: "Grupo_Etario", aoa: agesAoa, percentCols: [2] },
    { name: "Habilitacao_Escolar", aoa: schoolsAoa, percentCols: [2] },
    { name: "Nivel_Qualificacao", aoa: qualAoa, percentCols: [2] },
  ]);
}
